import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import { backend } from "../../components/apipath";

function ResetPassword() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get("token");

    const [formData, setFormData] = useState({
        newPassword: "",
        confirmPassword: "",
    });

    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.newPassword || !formData.confirmPassword) {
            return Swal.fire({
                title: "糟糕！",
                text: "請輸入完整密碼欄位",
                confirmButtonColor: "#224040",
                imageUrl: "/member_img/logo.svg",
                color: "#224040",
            });
        }

        if (formData.newPassword !== formData.confirmPassword) {
            return Swal.fire({
                title: "密碼不一致",
                text: "請確認兩次密碼輸入一致",
                confirmButtonColor: "#224040",
                imageUrl: "/member_img/logo.svg",
                color: "#224040",
            });
        }

        try {
            setIsSubmitting(true);

            const res = await fetch(`${backend}join/reset-password`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    token,
                    newPassword: formData.newPassword,
                }),
            });

            const result = await res.json();

            if (result.code === "200") {
                Swal.fire({
                    title: "密碼已更新",
                    text: "請使用新密碼重新登入",
                    confirmButtonColor: "#224040",
                    imageUrl: "/member_img/logo.svg",
                    color: "#224040",
                }).then(() => {
                    navigate("/member/memberlogin");
                });
            } else {
                Swal.fire({
                    title: "錯誤",
                    text: result.message || "重設失敗",
                    confirmButtonColor: "#224040",
                    imageUrl: "/member_img/logo.svg",
                    color: "#224040",
                });
            }
        } catch (err) {
            console.error("密碼重設失敗：", err);
            Swal.fire({
                title: "伺服器錯誤",
                text: "請稍後再試",
                confirmButtonColor: "#224040",
                imageUrl: "/member_img/logo.svg",
                color: "#224040",
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    useEffect(() => {
        if (!token) {
            Swal.fire({
                title: "錯誤",
                text: "連結錯誤或已過期",
                confirmButtonColor: "#224040",
                imageUrl: "/member_img/logo.svg",
                color: "#224040",
            }).then(() => {
                navigate("/member/memberlogin");
            });
        }
    }, [token, navigate]);

    return (
        <div className="container mb100 mt100">
            <h2 className="font-weight-bold pb-5 text-center">重設密碼</h2>
            <div className="card w-75 p-5 m-auto">
                <div className="card-body">
                    <form onSubmit={handleSubmit}>
                        <div className="form-group mb-4">
                            <label>新密碼</label>
                            <input
                                type="password"
                                name="newPassword"
                                className="form-control"
                                value={formData.newPassword}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group mb-4">
                            <label>確認新密碼</label>
                            <input
                                type="password"
                                name="confirmPassword"
                                className="form-control"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <button type="submit" className="btn btn-primary w-100" disabled={isSubmitting}>
                            {isSubmitting ? "送出中..." : "確認重設"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default ResetPassword;
